import { useEffect, useState } from "react";

// Every frui Dialog, Sheet, and Drawer renders through `@radix-ui/react-dialog`
// (Drawer via `vaul`, which itself wraps `DialogPrimitive.Content`) — all three
// carry `role="dialog"`. AlertDialog is the one exception, on `role="alertdialog"`
// via `@radix-ui/react-alert-dialog`. Together these cover every "modal, drawer,
// or sheet" surface without needing each call site to report its own open state.
const OVERLAY_SELECTOR = '[role="dialog"], [role="alertdialog"]';

/** Whether any modal, drawer, or sheet is currently open anywhere on the page. */
export function useOverlayVisible() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const check = () => setVisible(document.querySelector(OVERLAY_SELECTOR) !== null);
    check();

    // Radix mounts/unmounts these on open/close rather than toggling a class, so
    // presence in the DOM (not a style or class change) is what we watch for.
    const observer = new MutationObserver(check);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  return visible;
}
